export const EMPTYALLREDUCERS = "EMPTY_ALL_REDUCERS"